module.exports = __webpack_public_path__ + "static/media/candado.0b7b4661.svg";